export enum RadioDesigns {
  Circle = 'circle',
  Check = 'check',
}
